const sentryDenyUrls = [
  /^https:\/\/accounts\.google\.com\/.*$/, // 'https://accounts.google.com/gsi/client',
  /^https:\/\/apis\.google\.com\/.*$/, // 'https://apis.google.com/js/api.js',
  /^https:\/\/assets\.customer\.io.*$/, // 'https://assets.customer.io/assets/track.js',
  /^https:\/\/assets\.calendly\.com.*$/, // 'https://assets.calendly.com/assets/external/widget.js',
  /https:\/\/www\.googletagmanager\.com.*$/, // 'https://www.googletagmanager.com/gtag/js?id=UA-159824587-1',
  /^https:\/\/code\.tidio\.co.*$/, // 'https://code.tidio.co/gilj5hcmdev12edww6jdexzzutlxnvlp.js',
  /^https:\/\/www\.google-analytics\.com.*$/, // 'https://www.google-analytics.com/',
  /^https:\/\/connect\.facebook\.net.*$/, // 'https://connect.facebook.net',
  /^.*\.googletagmanager\.com.*$/, // 'www.googletagmanager.com',
  /^https:\/\/snap\.licdn\.com.*$/, // 'https://snap.licdn.com',
  /^https:\/\/static\.ads-twitter\.com.*$/, // 'https://static.ads-twitter.com/uwt.js',
  /^https:\/\/analytics\.twitter\.com\/.*$/, // 'https://analytics.twitter.com',
  /^https:\/\/analytics.tiktok\.com.*$/, // 'https://analytics.tiktok.com',
  /^https:\/\/js-agent.newrelic\.com.*$/ // 'https://js-agent.newrelic.com',
];

module.exports = { sentryDenyUrls };
